export class BaseModel {
	// Edit
	// _isEditMode = false;
	// Log
	// _userId = 0; // Admin
	createdAt: string;
	updatedAt: string;
}
